<script>
export default {
  methods: {
    $can(permission) {
      return this.$page.props.auth.user.permissions.indexOf(permission) !== -1;
    },
  },
};
</script>
